import React from 'react';

function Haiti(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124104)">
        <mask
          id="mask0_800_124104"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124104)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#2E42A5"
          />
          <mask
            id="mask1_800_124104"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_124104)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 12V24H36V12H0Z"
              fill="#E31D1C"
            />
            <rect x="11.25" y="8" width="13.5" height="8" fill="white" />
            <mask
              id="mask2_800_124104"
                 style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="11"
              y="8"
              width="14"
              height="8"
            >
              <rect x="11.25" y="8" width="13.5" height="8" fill="white" />
            </mask>
            <g mask="url(#mask2_800_124104)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.25 14.5778C11.25 14.5778 14.4904 13.8205 18 13.8667C21.5096 13.9129 24.75 14.7556 24.75 14.7556V16H11.25V14.5778Z"
                fill="#279E19"
              />
              <path
                d="M18.083 8.90116C18.083 8.90116 17.0355 8.48178 16.3044 8.48178C15.5732 8.48178 15.167 9.12189 15.167 9.12189"
                stroke="#026A16"
                strokeWidth="0.5"
              />
              <path
                d="M18.3156 9.32156C18.3156 9.32156 17.3517 9.01514 16.6789 9.01514C16.0061 9.01514 15.6323 9.48283 15.6323 9.48283"
                stroke="#026A16"
                strokeWidth="0.5"
              />
              <path
                d="M18.3155 9.67709C18.3155 9.67709 17.6025 9.37067 17.1048 9.37067C16.6071 9.37067 16.3306 9.83836 16.3306 9.83836"
                stroke="#026A16"
                strokeWidth="0.5"
              />
              <path
                d="M18.0227 10.0326C18.0227 10.0326 17.5822 9.72623 17.2747 9.72623C16.9672 9.72623 16.7964 10.1939 16.7964 10.1939"
                stroke="#026A16"
                strokeWidth="0.5"
              />
              <path
                d="M17.985 10.2752C17.985 10.2752 17.8088 10.0818 17.6859 10.0818C17.5629 10.0818 17.4946 10.3771 17.4946 10.3771"
                stroke="#026A16"
                strokeWidth="0.5"
              />
              <path
                d="M17.9175 8.90116C17.9175 8.90116 18.9649 8.48178 19.6961 8.48178C20.4273 8.48178 20.8335 9.12189 20.8335 9.12189"
                stroke="#026A16"
                strokeWidth="0.5"
              />
              <path
                d="M17.6849 9.32156C17.6849 9.32156 18.6488 9.01514 19.3216 9.01514C19.9944 9.01514 20.3682 9.48283 20.3682 9.48283"
                stroke="#026A16"
                strokeWidth="0.5"
              />
              <path
                d="M17.685 9.67709C17.685 9.67709 18.398 9.37067 18.8957 9.37067C19.3934 9.37067 19.6699 9.83836 19.6699 9.83836"
                stroke="#026A16"
                strokeWidth="0.5"
              />
              <path
                d="M17.9778 10.0326C17.9778 10.0326 18.4183 9.72623 18.7258 9.72623C19.0333 9.72623 19.2041 10.1939 19.2041 10.1939"
                stroke="#026A16"
                strokeWidth="0.5"
              />
              <path
                d="M18.0155 10.2752C18.0155 10.2752 18.1917 10.0818 18.3146 10.0818C18.4376 10.0818 18.5059 10.3771 18.5059 10.3771"
                stroke="#026A16"
                strokeWidth="0.5"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.8737 10.3982C17.8737 10.3982 17.7451 11.7356 17.7451 12.2799C17.7451 12.8242 17.8737 13.9986 17.8737 13.9986H18.2042C18.2042 13.9986 18.2042 12.7343 18.2042 12.2799C18.2042 11.8255 18.0102 10.3982 18.0102 10.3982H17.8737Z"
                fill="#FECA00"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.574 11.9185C16.574 11.9185 15.7593 12.3061 15.7593 13.4536L16.574 14.8392H18.0443V12.5574L16.574 11.9185Z"
                fill="#C51918"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.3665 10.826C15.3665 10.826 13.4644 11.3269 13.4644 13.1747L15.9288 13.3616C15.9288 13.3616 15.7942 12.288 16.5526 11.7914L15.3665 10.826Z"
                fill="#0A328C"
              />
              <path
                d="M14.5811 10.1209L17.8441 12.779"
                stroke="#FFD018"
                strokeWidth="0.5"
              />
              <path
                d="M13.4482 10.7228L17.9994 13.3498"
                stroke="#FFD018"
                strokeWidth="0.5"
              />
              <path
                d="M12.6646 11.7396L17.7941 13.8248"
                stroke="#FFD018"
                strokeWidth="0.5"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.4775 13.1602L16.8814 13.4985L16.6898 13.9208H16.1501L16.5177 14.1593L17.3465 14.3318V13.9208H18.0723V14.7939H16.5177L15.9214 14.1593C15.9214 14.1593 15.4206 14.5982 14.9318 14.5982C14.4431 14.5982 13.9612 14.4556 13.9612 13.9771C13.9612 13.4985 13.9612 13.6441 13.9612 13.6441L13.4775 13.4985V13.1602Z"
                fill="#FECA00"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.9607 11.9185C18.9607 11.9185 19.7754 12.3061 19.7754 13.4536L18.9607 14.8392H17.4904V12.5574L18.9607 11.9185Z"
                fill="#C51918"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.1682 10.826C20.1682 10.826 22.0703 11.3269 22.0703 13.1747L19.6059 13.3616C19.6059 13.3616 19.7405 12.288 18.9821 11.7914L20.1682 10.826Z"
                fill="#0A328C"
              />
              <path
                d="M20.9536 10.1209L17.6906 12.779"
                stroke="#FFD018"
                strokeWidth="0.5"
              />
              <path
                d="M22.0864 10.7228L17.5353 13.3498"
                stroke="#FFD018"
                strokeWidth="0.5"
              />
              <path
                d="M22.8701 11.7396L17.7406 13.8248"
                stroke="#FFD018"
                strokeWidth="0.5"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22.0571 13.1602L18.6533 13.4985L18.8449 13.9208H19.3845L19.017 14.1593L18.1882 14.3318V13.9208H17.4624V14.7939H19.017L19.6133 14.1593C19.6133 14.1593 20.1141 14.5982 20.6028 14.5982C21.0916 14.5982 21.5734 14.4556 21.5734 13.9771C21.5734 13.4985 21.5734 13.6441 21.5734 13.6441L22.0571 13.4985V13.1602Z"
                fill="#FECA00"
              />
            </g>
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124104">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Haiti;
